import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Panel, Nav, NavItem, Button, Modal } from "react-bootstrap";
import LoaderPanel from "../components/LoaderPanel";
import LoaderButton from "../components/LoaderButton";
import withLoadSave from "../components/LoadSave";
import { FormControlLabel, SelectLabel, CheckboxLabel } from "../components/FormControls";
import getvalue from "../utils/getvalue";
import SaveNavbar from "../components/SaveNavbar";
import TitlePage from "../components/TitlePage";
import { EDTabs, EDFormSection, EDFormBox, EDFormGroup } from "../components/EDDOM";
import Select2 from "react-select2-wrapper";
import _ from "underscore";
import Datetime from "react-datetime";
import moment from "moment";

import "react-select2-wrapper/css/select2.css";

class Customer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: null,
    };
  }

  modalChanged = event => {
    this.setState({[event.target.id]: getvalue(event)});
  }

  validateForm() {
    const d = this.props.data;
    return d.name && d.frontend && d.routes && d.routes.length && d.hourlimit !== null && d.daylimit !== null && d.initiallimit !== null && d.limitincr !== null && d.limitincrmins !== null;
  }

  handleChange = event => {
    this.props.update({[event.target.id]: {$set: getvalue(event)}})
  }

  handleDateChange = v => {
    this.props.update({trialend: {$set: v?v.format():v}})
  }

  handleSubmit = async event => {
    event.preventDefault();

    var id = (await this.props.save()).data.id;

    if (!id) {
      this.props.history.push('/customers');
    } else {
      this.props.history.push('/customers/edit-users?id=' + id);
    }
  }

  switchView = url => {
    this.props.history.push(url);
  }

  goBack = () => {
    this.props.history.push('/customers');
  }

  updateCredits = name => {
    this.setState({showModal: name, newcredits: this.props.credits[name]});
  }

  navbarButtons = () => {
    return (
      <LoaderButton
        id="customer-settings-buttons-dropdown"
        text="Save and Close"
        loadingText="Saving..."
        className="green"
        disabled={!this.validateForm() || this.props.isSaving}
        onClick={this.handleSubmit}
        splitItems={[
          { text: 'Cancel', onClick: this.goBack }
        ]}
      />
    )
  }

  modalClose = async ok => {
    var name = this.state.showModal;

    this.setState({showModal: null});
  
    if (!ok) {
      return;
    }
  
    await axios.patch('/api/companies/' + this.props.id + '/credits', {
      [name]: this.state.newcredits,
    });

    this.props.reloadExtra();
  }

  render() {
    var routeitems = _.map(this.props.routes, r => ({id: r.id, text: r.name}));

    return (
      <SaveNavbar isAdmin={true} title={this.props.id === 'new'?'Create Customer':'Customer Settings'} disabled={!this.validateForm()}
                  onBack={this.goBack} buttons={this.navbarButtons()} isSaving={this.props.isSaving}>
        {
          this.props.id !== 'new' && 
            <TitlePage tabs={
              <EDTabs>
                <Nav className="nav-tabs" activeKey="1">
                  <NavItem eventKey="1" disabled>Settings</NavItem>
                  <NavItem eventKey="2" onClick={this.switchView.bind(null, '/customers/edit-users?id=' + this.props.id)}>Users</NavItem>
                  <NavItem eventKey="3" onClick={this.switchView.bind(null, '/customers/list-approval?id=' + this.props.id)}>List Approval</NavItem>
                </Nav>
              </EDTabs>
            }/>
        }
        <LoaderPanel isLoading={this.props.isLoading}>
          <EDFormSection onSubmit={this.handleSubmit} noShadow>
          {
            this.props.routes && !this.props.routes.length &&
              <h4 className="text-center space-top">
                No postal routes are configured. This customer will not be able to send mail until you <Link to="/routes/edit?id=new">create a postal route</Link>.
              </h4>
          }
          {
            this.props.frontends && !this.props.frontends.length ?
            <h4 className="text-center space-top">
              No frontends are configured. You should <Link to="/frontends/edit?id=new">create a frontend</Link> before you configure any customers.
            </h4>
            :
            <EDFormBox>
              <FormControlLabel
                id="name"
                label="Company Name"
                obj={this.props.data}
                onChange={this.handleChange}
              />
              <SelectLabel
                id="frontend"
                label="Frontend"
                obj={this.props.data}
                onChange={this.handleChange}
                options={this.props.frontends}
                space
              />
              <EDFormGroup space>
                <label>Postal Routes</label>
                <div>
                  <Select2
                    id="routes"
                    multiple
                    data={routeitems}
                    value={this.props.data.routes}
                    onChange={this.handleChange}
                    style={{width:'100%'}}
                  />
                </div>
                <span className="help-block">Selecting more than one postal route will allow the customer to choose which route to use when sending</span>
              </EDFormGroup>
              <Panel id="price-panel" className="space20">
                <Panel.Heading>
                  <Panel.Title toggle>
                    Edit Send Limits
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Collapse>
                  <Panel.Body>
                    <FormControlLabel
                      id="minlimit"
                      label="Send Limit per Minute"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                      help="Hard send limit per minute, disabled by default"
                    />
                    <FormControlLabel
                      id="hourlimit"
                      label="Send Limit per Hour"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                      help="Hard hourly send limit"
                    />
                    <FormControlLabel
                      id="daylimit"
                      label="Send Limit per Day"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                      help="Hard daily send limit. The system will never set the 'Current Limit' above this."
                      space
                    />
                    <FormControlLabel
                      id="initiallimit"
                      label="Initial Daily Limit"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                      help="The system will set the 'Current Limit' to this value at the start of each day"
                      space
                    />
                    <FormControlLabel
                      id="limitincr"
                      label="Limit Increase %"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      step="0.01"
                      style={{width: '90px'}}
                      help="Once the customer hits their current daily send limit, the system will increase the 'Current Limit' by this % after the 'Increase Wait Time' has elapsed, if the customer's stats are good. 100% means the limit is doubled."
                      space
                    />
                    <FormControlLabel
                      id="limitincrmins"
                      label="Increase Wait Time (Mins)"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="1"
                      style={{width: '90px'}}
                      help="How long to wait after the 'Current Limit' is reached before checking whether or not to increase the limit."
                      space
                    />
                    <FormControlLabel
                      id="currentlimit"
                      label="Current Limit"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                      help="The customer's actual current daily send limit. The system will set this automatically but you can manually set it to a different value here."
                      space
                    />
                  </Panel.Body>
                </Panel.Collapse>
              </Panel>
              { this.props.credits && this.props.data.paid &&
                <div style={{marginTop: '10px'}}>
                  <div>
                    <label style={{width: '150px'}}>Unlimited Credits:</label> <span style={{display: 'inline-block', minWidth: '100px'}}>{this.props.credits.unlimited}</span> <Button onClick={this.updateCredits.bind(null, 'unlimited')}>Update</Button>
                  </div>
                  <div>
                    <label style={{width: '150px'}}>Monthly Credits:</label> <span style={{display: 'inline-block', minWidth: '100px'}}>{this.props.credits.expire}</span> <Button onClick={this.updateCredits.bind(null, 'expire')}>Update</Button>
                  </div>
                </div>
              }
              {/*
              <Panel id="price-panel">
                <Panel.Heading>
                  <Panel.Title toggle>
                    Edit Payment Settings
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Collapse>
                  <Panel.Body>
                    <FormControlLabel
                      id="price"
                      label="Price (USD)"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      step="0.01"
                      style={{width: '90px'}}
                    />
                    <SelectLabel
                      id="period"
                      label="Billing Period"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      style={{width: 'auto', marginBottom: '10px'}}
                    >
                      <option value="monthy">Monthly</option>
                      <option value="yearly">Yearly</option>
                    </SelectLabel>
                    <FormControlLabel
                      id="credits"
                      label="Credits Per Period"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="overageprice"
                      label="Overage Price (USD)"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      step="0.01"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="overagecredits"
                      label="Overage Credits"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="hourlimitpostupgrade"
                      label="After Upgrade Set Hourly Limit To"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="daylimitpostupgrade"
                      label="After Upgrade Set Daily Limit To"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="initiallimitpostupgrade"
                      label="After Upgrade Set Initial Daily Limit To"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="limitincrpostupgrade"
                      label="After Upgrade Set Limit Increase % To"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="0"
                      step="0.01"
                      style={{width: '90px'}}
                    />
                    <FormControlLabel
                      id="limitincrminspostupgrade"
                      label="After Upgrade Set Increase Wait Time (Mins) To"
                      obj={this.props.data}
                      onChange={this.handleChange}
                      type="number"
                      min="1"
                      style={{width: '90px'}}
                    />
                  </Panel.Body>
                </Panel.Collapse>
            </Panel>*/}
              <EDFormGroup space>
                <label>Trial Expiration:</label>
                <div style={{width: '250px'}}>
                  <Datetime value={this.props.data.trialend?moment(this.props.data.trialend):''} onChange={this.handleDateChange} />
                </div>
              </EDFormGroup>
              <CheckboxLabel
                id="exampletemplate"
                label="Example Data Template"
                obj={this.props.data}
                onChange={this.handleChange}
                help="Only one customer can be the example template at a time. If checked, broadcast, contact, segment and funnel data from this customer will be copied to every new customer in the system."
                space
              />
              <CheckboxLabel
                id="reverse_funnel_order"
                label="Reverse Funnel Order"
                obj={this.props.data}
                onChange={this.handleChange}
                help={
                  <span>
                    Default: First in, first out.<br/>
                    Reverse: Last in, first out.
                  </span>
                }
                space
              />
              <CheckboxLabel
                id="skip_list_validation"
                label="Don't Validate Lists"
                obj={this.props.data}
                onChange={this.handleChange}
                help="If unchecked, all contact lists uploaded by this customer will require backend admin approval."
                space
              />
            </EDFormBox>
          }
          </EDFormSection>
          <Modal show={this.state.showModal !== null} bsSize="small">
            <Modal.Header>
              <Modal.Title>
                Update Credits
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormControlLabel
                id="newcredits"
                obj={this.state}
                type="number"
                min="0"
                onChange={this.modalChanged}
                label="Credits"
                style={{width: '100px'}}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.modalClose.bind(this, true)} bsStyle="primary" disabled={this.state.newcredits === null}>Save</Button>
              <Button onClick={this.modalClose.bind(this, false)}>Cancel</Button>
            </Modal.Footer>
          </Modal>
        </LoaderPanel>
      </SaveNavbar>
    );
  }
}

export default withLoadSave({
  extend: Customer,
  initial: {
    name: '',
    frontend: '',
    routes: [],
    minlimit: 999999999,
    hourlimit: 999999999,
    daylimit: 999999999,
    initiallimit: 999999999,
    limitincr: 0,
    limitincrmins: 0,
    exampletemplate: false,
    price: null,
    period: 'monthly',
    credits: null,
    overageprice: null,
    overagecredits: null,
    hourlimitpostupgrade: 999999999,
    daylimitpostupgrade: 999999999,
    initiallimitpostupgrade: 999999999,
    limitincrpostupgrade: 0,
    limitincrminspostupgrade: 0,
    skip_list_validation: true,
  },
  get: async ({id}) => (await axios.get('/api/companies/' + id)).data,
  post: ({data}) => axios.post('/api/companies', data),
  patch: ({id, data}) => axios.patch('/api/companies/' + id, data),
  extra: {
    frontends: async () => (await axios.get('/api/frontends')).data,
    routes: async () => _.filter((await axios.get('/api/routes')).data, r => r.published),
    credits: async ({id}) => {
      if (id === 'new')
        return null;
      return (await axios.get('/api/companies/' + id + '/credits')).data;
    },
  },
  extramerge: {
    frontend: 'frontends',
  }
});



// WEBPACK FOOTER //
// ./src/containers/Customer.js